import staticUrl from 'components/helpers/statics';

const CURRENT_YEAR = new Date().getFullYear();

export default function LogsReportPage({children})  {
  return (
    <div className="report-page page">
      <div className="report-header">
        <img src={staticUrl('GEOAPP_LOGO')} className="logo" />
        <h1>PILE INSTALLATION<br/>OBSERVATION RECORD</h1>
      </div>

      {children}

      <div className="report-footer">
        <p>MAGNUM GeoApp<sup>&reg;</sup> Software, Version {VERSION}, Copyright {CURRENT_YEAR}.</p>
      </div>
    </div>
  );
}
